import { ReactNode } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Stack, IconButton, Theme } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { SxProps } from '@mui/material/styles';
import Link from 'next/link';
import BodyStrong from '@/components/typography/BodyStrong';
interface MobileAppBarProps {
  title: string;
  navigationItem?: ReactNode;
  disableNavigation?: boolean;
  backTo?: (() => void) | string;
  sx?: SxProps<Theme>;
}
const MobileAppBar = (props: MobileAppBarProps) => {
  return <AppBar position='fixed' sx={props.sx} component='div' data-sentry-element="AppBar" data-sentry-component="MobileAppBar" data-sentry-source-file="MobileAppBar.tsx">
      <Toolbar data-sentry-element="Toolbar" data-sentry-source-file="MobileAppBar.tsx">
        <Stack sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }} data-sentry-element="Stack" data-sentry-source-file="MobileAppBar.tsx">
          {!props.disableNavigation && (typeof props.backTo === 'string' ? <Link href={props.backTo ? props.backTo : '/'} style={{
          display: 'inherit'
        }}>
                {props.navigationItem ? props.navigationItem : <ArrowForward sx={{
            color: 'text.text'
          }} />}
              </Link> : <IconButton sx={{
          bgcolor: 'transparent'
        }} onClick={props.backTo}>
                {props.navigationItem ? props.navigationItem : <ArrowForward />}
              </IconButton>)}
          <Stack sx={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%'
        }} data-sentry-element="Stack" data-sentry-source-file="MobileAppBar.tsx">
            <BodyStrong variant='bodyStrong__Wallfund' padding={1.5} data-sentry-element="BodyStrong" data-sentry-source-file="MobileAppBar.tsx">
              {props.title}
            </BodyStrong>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>;
};
export default MobileAppBar;